import domWrap from "./domWrap";

export default (el,top) => {
	const 	elementTop = domWrap(el).offset().top;
	window.scroll({ 
		top: Math.floor(top ? elementTop : elementTop + el.offsetHeight - 75), 
		behavior: 'smooth' 
	});
}